import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Catalog from "@/pages/Catalog";
import Flyer from "@/pages/Flyer";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CoursePage from "@/pages/CoursePage";
import Leads from "@/pages/Leads";
import MustChangePassword from "@/pages/MustChangePassword";
import { StudentPreviewBar } from "@/components/StudentPreviewBar";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <MustChangePassword />;
  return children;
}

function InstructorOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <MustChangePassword />;
  if (user.role !== "instructor") return <Navigate to="/dashboard" replace />;
  return children;
}

function AuthOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/flyer/:code" element={<Flyer />} />
            <Route path="/login" element={<AuthOnly><Login /></AuthOnly>} />
            <Route path="/register" element={<AuthOnly><Register /></AuthOnly>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/leads" element={<InstructorOnly><Leads /></InstructorOnly>} />
            <Route path="/courses/:courseId" element={<Protected><CoursePage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <StudentPreviewBar />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
